import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmationModalComponent } from "../../common/confirmation-modal/confirmation-modal.component";
import { OtpComponent } from "../otp/otp.component";

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent {
  loginForm: FormGroup; // Create a FormGroup
  isButtonOn = true;

  constructor(
    public ref: MatDialogRef<SignInComponent>,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private dialog: MatDialog
  ) {
    this.loginForm = this.formBuilder.group({
      your_name: ["", Validators.required],
      agreeTerm: [false],
    });
  }

  onSubmit() {
    if (!this.isButtonOn) {
      return;
    }

    if (this.loginForm.valid) {
      this.isButtonOn = false;

      const formValue = this.loginForm.value;
      const body = {
        mobile: formValue.your_name.toLowerCase(),
        access_type: "web",
        otp_in: formValue.agreeTerm,
      };

      this.auth.otpRequest(body).subscribe(
        (res: any) => {
          this.isButtonOn = true;

          if (res.error === false) {
            this.openOtp(
              formValue.your_name.toLowerCase(),
              res.details.otp_ref
            );
          } else {
            this.openDialog(res.error_message);
          }
        },
        (error) => {
          this.isButtonOn = true;
          this.openDialog(error.error.message);
        }
      );
    }
  }

  openOtp(number: string, otpRef: string) {
    this.isButtonOn = true;
    const dialogRef = this.dialog.open(OtpComponent, {
      enterAnimationDuration: "200ms",
      data: {
        number: number,
        ref: otpRef,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "done") {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    this.ref.close();
  }

  openDialog(err: String) {
    this.dialog.open(ConfirmationModalComponent, {
      enterAnimationDuration: "350ms",
      data: {
        error: err,
      },
    });
  }
}
